export default __webpack_public_path__ + "static/media/lt-logo-green.d3578c3a.svg";